var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('h1',{staticClass:"title"},[_vm._v("ご注文ありがとうございました")]),_vm._v(" "),_c('p',[_vm._v("ご入力頂いたメールアドレス宛にご注文内容を送信しました")]),_vm._v(" "),_c('p',[_vm._v("ご注文内容はマイページからも確認ができます")]),_vm._v(" "),_c('button',{staticClass:"button is-primary is-fullwidth",on:{"click":_vm.toMypage}},[_vm._v("マイページへ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2f84a30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/photobuy/pages/Complete.vue
// module id = null
// module chunks = 